import {Component} from '@angular/core';
import {CookiesManager} from '../../core/cookies';
import {SessionService} from '../../core/security';
import {MenuResizeService} from './menu/resizer/menu.resizer.service';

@Component({
    selector: 'space',
    providers: [MenuResizeService],
    template: require('./space.template.html')
})
export class SpaceComponent {

    private interval;

    constructor(private _sessionService: SessionService) {
    }

    ngOnInit() {
        if (!this.interval) {
            this.interval = setInterval(() => this.incrementIdleTimer(), 10000);
        }
    }

    ngOnDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    private incrementIdleTimer() {
        if (!CookiesManager.isTokenExist()) {
            this._sessionService.expire();
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/space/space.component.ts